import React, { useContext, useEffect, useState } from "react";
import './styles.scss';
import { Button, Checkbox, CheckboxProps, Col, Form, Input, InputNumber, Modal, Row, Select } from "antd";
import { TransfersBetweenBoxesProps } from "./types";
import { valuesCommission } from "../CurrentAccountComission";
import { OperationTypeProps, useOperations } from "../../../Services/useOperations";
import { ResponseAccounts, useAccounts } from "../../../Services/useAccounts";
import { VariablesContext } from "../../../Contexts/UserContext/VariablesContext";
import { UserContext } from "../../../Contexts/UserContext/UsersContext";
import { AllClientsProps, useGetAllClients } from "../../../Services/useGetAllClients";
import { CurrencyProps, useGetCurrency } from "../../../Services/useGetCurrency";
import { Transaction } from "../../../Services/useGetMovements";
import ModalTitle from "../../ModalTitle";
import { OperationsContext } from "../../../Contexts/UserContext/OperationsContext";
import NewCustomer from "../../NewCustomer";
import CurrentAccountComission from "../CurrentAccountComission";
import { useForm } from "antd/es/form/Form";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons" 
export interface FilterValues{
    value: string,
    label: string,
    key: number,
}

export interface ValuesForm {
    amount: number,
    approved: boolean,
    description: string,
    destination_customer: number,
    destination_currency: number,    
    origin_customer: number,
    origin_currency: number,    
}

export const TransfersBetweenAccounts: React.FC<TransfersBetweenBoxesProps> =({
    form,
})=>{
    

    const [ form_commission ] = useForm()

    const {createOperation, editOperation, getOperation} = useOperations()
    const {getAccountsCurrencyAndCustomer} = useAccounts() 
    const { setShowForms, showForms, dataTransactionsToForm, setDataTransactionsToForm } = useContext(VariablesContext)
    const {setRowSelect} =useContext(OperationsContext)
    const { data: currency} = useGetCurrency()
    const { data: clients } = useGetAllClients()
    const {userData} = useContext(UserContext)
    const {collapsedFilsters, setCollapsedFilters} = useContext(VariablesContext)
    const { Option } = Select;
    const mandatory = [
        {
            required: true,
            message:'Este campo es obligatorio'
        }
    ]

    const [loadingBtn, setLoadingBtn] = useState(false)
    const [approved, setaproved] = useState(false)
    const [selectedCurrency, setSelectedCurrency] = useState<{id: number, name: string, sign: string} | undefined>()
    const [selectedCustomer, setSelectedCustomer] = useState<{id: number, name: string} | undefined>()
    const [balance, setBalance] = useState<ResponseAccounts>()
    const [spanError, setSpanError] = useState<string>() 
    const [secondSelectorList, setSecondSelectorList] = useState<AllClientsProps[]>([])
    const [secondCurrencySelectorList, setCurrencySecondSelectorList] = useState<CurrencyProps[]>([])
    const [ammmountSign, setAmmountSign] = useState<string>('$')
    const [transactionsData, setTransactionsData] = useState<Transaction>()
    const [showAddComision, setShowAddComission] = useState<boolean>(false)
    const [values, setValues] = useState<valuesCommission>()
    const [listComission, setListCommission]= useState<valuesCommission[]>([])
    const [disabledForm, setDisableForm] = useState<{
        disable: boolean,
        approved: boolean,
        deleted: boolean,
        operationNumber: number | undefined
    }>({
        disable: true,
        approved: false,
        deleted: false,
        operationNumber: undefined
    })

    const originCustomer = Form.useWatch('origin_customer', form);
    const destinationCustomer = Form.useWatch('destination_customer', form);
    const originCurrency = Form.useWatch('origin_currency', form); 

    useEffect(() => {
        if(dataTransactionsToForm ){
            updatedForm(dataTransactionsToForm)    
        }else{
            setDisableForm({
                disable: false,
                approved: false,
                deleted: false,
                operationNumber: undefined
            })
            form.resetFields(undefined) 
        }        
    }, []);

    useEffect(()=>{
        if(selectedCurrency && selectedCustomer){
           changeOriginAccount() 
        }        
    },[selectedCurrency, selectedCustomer])

    const updatedForm = async(response: Transaction) =>{
        if(response){
            setTransactionsData(response)
            setaproved(response.approved)  

            if(response.related_load_operations){
                loadListCommission(response.related_load_operations)
            }

            setDisableForm({
                disable: response.approved || response.deleted ? true : false,
                approved: response.approved || false,
                deleted: response.deleted || false,
                operationNumber: response.operation_id
            })

            onChangeFirstClient(response.origin_account?.customer?.id)
            onChangeFirstCurrency(response.origin_account?.currency?.id)
            
            form.setFieldsValue({                
                destination_customer: response.destination_account.customer?.id,
                origin_customer: response.origin_account?.customer?.id || '',
                origin_currency: response.origin_account?.currency?.id || '',
                amount: response.debit ? Number(response.debit) : Number(response.credit),
                description: response.description
            });                 
        }
    }

    const loadListCommission = (movements: Transaction[]) =>{
        let data: valuesCommission[] = []
        movements.map((item, index)=>{    
            data.push({
                approved: item.approved,  
                approved_db: item.approved,
                currency_id: item.origin_account.currency.id,
                customer_id: item.origin_account.customer.id,
                debit: item.debit ? Number(item.debit.toLocaleString('es-ARG',{maximumFractionDigits: 2, minimumFractionDigits:2})) : undefined,
                description: item.description,  
                id: item.id,
                key: index,
                operation_id: item.operation_id,        
                type_id: 16,                    
            })                                            
            setListCommission(data)
        })
    }


    const handleCancel =()=>{
        setShowForms(Object.fromEntries(Object.keys(showForms).map(key => [key, false])))// pone todos en false
        if(dataTransactionsToForm){
            setDataTransactionsToForm(undefined)
        }      
        form.resetFields(undefined)   
        setTransactionsData(undefined)
        setaproved(false)
        setRowSelect(undefined)
    }

    const confirmSave = async(operationData: OperationTypeProps) =>{
        let newData
        const doNotUpdate = listComission?.some(x => !x.approved_db && !x.deleted) ?? false // Confirmo si tiene que actualizar datos en tabla acá o cuando guarda las comisiones

        if(dataTransactionsToForm){
            newData = await editOperation(handleCancel, dataTransactionsToForm.id.toString(), operationData, doNotUpdate)
        }else{
            newData = await createOperation(handleCancel, operationData, doNotUpdate)
        }                  
        if(newData && newData !== 'error'){
            saveCommissions(newData)
        }
        setLoadingBtn(false) 
        setCollapsedFilters(!collapsedFilsters)
         
    }

    const saveCommissions = (response: Transaction)=>{
        let newData
        let enabled: valuesCommission[] = []
        listComission?.forEach((item)=>{
            if(!item.approved_db){
                enabled.push(item)
            }
        })
        enabled?.map(async(item, index)=>{
            item.related_load_operation_id = response.id
            let doNotUpload = (index == enabled.length - 1) ? false : true
            if(item.id){
                newData = await editOperation(handleCancel, item.id.toString(), item, doNotUpload)                            
            }else{
                newData = await createOperation(handleCancel, item, doNotUpload)
            }
                        
        })        
    }

    const handleSave = async (e: ValuesForm)=>{
        let operationData: OperationTypeProps | undefined
        if(userData){
            operationData={
                type_id: 6, //correspondiente a Transferencia entre cuentas clientes, por eso va harcord
                destination_customer_id: e.destination_customer,
                origin_customer_id: e.origin_customer,   
                currency_id: e.origin_currency,
                debit: e.amount,
                approved: approved,
                description: e.description 
            } 
        }  
         if(operationData){
            let sign = currency?.find?.((x)=> x.id === Number(e.origin_currency))?.sign || ''
            let origin_customer = clients.find?.((x)=>x.id ===e.origin_customer)?.first_name + ' ' + clients.find?.((x)=>x.id ===e.origin_customer)?.last_name
            let destination_customer = clients.find?.((x)=>x.id ===e.destination_customer)?.first_name + ' ' + clients.find?.((x)=>x.id === e.destination_customer)?.last_name

            Modal.confirm({
                title: 'Confirmar operación',
                okText: 'Confirmar',
                cancelText: 'Cancelar',
                onOk:()=> operationData && confirmSave(operationData),
                content: (
                    <div>
                        <p><strong>Transferencia entre cuentas</strong></p>
                        {origin_customer && <p><strong>Cuenta de origen: </strong> {origin_customer}</p>}    
                        {destination_customer && <p><strong>Cuenta de destino: </strong> {destination_customer}</p>}                                  
                        {e.amount && <p><strong>Monto: </strong>{sign} {Number(e.amount).toLocaleString("es-AR",{maximumFractionDigits:2, minimumFractionDigits:2})}</p>}                                
                         {   listComission && listComission.length > 0 &&                             <>
                                <div style={{borderTop: '1px solid gray', fontSize: 12, gap: 4}}>
                                    <p style={{margin: '5px 0px 0px'}}><strong>Comisiones:</strong></p>
                                    {listComission?.map((item)=>{
                                        if(!item.deleted){
                                            let customer = clients.find((x)=>x.id == item.customer_id)?.first_name + ' ' + clients.find((x)=>x.id == item.customer_id)?.last_name
                                            let currencySelected = currency.find((x)=>x.id == item.currency_id)?.sign
                                            return(
                                                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                                    <p style={{margin: '0px 5px 0px 0px'}}><strong>{customer}: </strong>
                                                        - {currencySelected} {Number(item.debit).toLocaleString('es-AR', {minimumFractionDigits: 2, maximumFractionDigits:2})}
                                                    </p>
                                                    <p style={{margin: 0}}>                                                   
                                                        <strong style={{ color: item.approved ? 'green' : 'orange' }}>
                                                            {item.approved ? 'Aprobado' : 'Sin aprobar'}
                                                        </strong>
                                                    </p>
                                                </div>                                       
                                            )
                                        }
                                    })}                           
                                </div> 
                                
                            </>                              
                        }    
                        <p>
                            <strong>Estado: </strong>
                            <strong style={{ color: operationData.approved ? 'green' : 'orange' }}>
                                {operationData.approved ? 'Aprobado' : 'Sin aprobar'}
                            </strong>
                        </p>                                                                                                                  
                    </div>
                ),
            });  
        }       
    }    

    const changeOriginAccount = async(
    ) =>{

        form.setFieldsValue({ destination_account: undefined });
        setSpanError(undefined)
        if(selectedCurrency && selectedCustomer){
            const balanceData = await getAccountsCurrencyAndCustomer(+selectedCustomer.id, +selectedCurrency.id) //consulto el balance de cliente
            //setCurrency({id: values.currency.id, sign: values.currency.sign})
            if(balanceData && balanceData){
                setBalance( balanceData)
            }    
            // setLoadingDestinationAccount(true)
            // const accountsData = await getAccountsCurrency(+selectedCurrency.id, setLoadingDestinationAccount) //endpoint para cargar segundo selector según moneda de origen
            // if(accountsData){
            //     let list = accountsData.filter((x)=> x.customer.id !== +selectedCustomer.id  )
            //     setListDestinationAccount(list)
            // }                    
        }          
    }

    const onChangeAmount = (e: any) =>{
        if(balance){ 
            if(e > balance.balance ){            
                let value = new Intl.NumberFormat('es-AR', { style: 'decimal', minimumFractionDigits: 2 }).format(balance.balance)
                setSpanError('El monto a transferir supera el monto de cuenta: ' + selectedCurrency?.sign + ' ' + value  )  
            }
        }
    }  

    const onChangeapproved: CheckboxProps['onChange'] = async (e) => {
        setaproved(e.target.checked); 
    };

    const onChangeFirstClient = (e: number) =>{
        if(clients){
            let list = clients.filter((x)=> x.id != e)
            setSecondSelectorList(list)
            form.resetFields(['destination_customer'])
            setSelectedCustomer({
                id: e,
                name: clients.find?.((x)=> x.id ===e)?.first_name + ' ' + clients.find?.((x)=> x.id ===e)?.last_name
            })
        }        
    }

    const onChangeFirstCurrency = (e: number) =>{        
        if(currency){
            const currencySelected = currency.find?.((x)=>x.id == e) ;
            let list = currency.filter((x)=> 
                x.id===e)
            setCurrencySecondSelectorList(list) 
            if(currencySelected){
                setAmmountSign(currencySelected.sign)
                setSelectedCurrency({
                    id: currencySelected.id, 
                    name: currencySelected.name,
                    sign: currencySelected.sign})
            }
        }        
        
    }

    const addCommission = () =>{
        setValues({
            approved: false,
            approved_db: false,   
            currency_id: originCurrency,
            customer_id: destinationCustomer,
            debit: undefined,
            deleted: false,
            description: '',   
            id: undefined,
            key: undefined,
            operation_id: undefined,        
            type_id: 16, //Comisión en cuenta cliente  
        })
        setShowAddComission(true)
    }

   const changePoint = (e:  React.KeyboardEvent<HTMLInputElement>)=>{
        const input = e.currentTarget as HTMLInputElement;
        const start = input.selectionStart ?? 0;
        const end = input.selectionEnd ?? 0;
        let newValue = input.value

        if (e.key === '.' && !e.shiftKey) {
            e.preventDefault();
            if (!input.value.includes(',')) {
                newValue = input.value.substring(0, start) + ',' + input.value.substring(end);
                input.value = newValue;
                input.setSelectionRange(start + 1, start + 1);
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }else if (e.key === ',') {
            e.preventDefault();
            if (!input.value.includes(',')) {
                newValue = input.value.substring(0, start) + ',' + input.value.substring(end);
                input.value = newValue;
                input.setSelectionRange(start + 1, start + 1);
                input.dispatchEvent(new Event('input', { bubbles: true }));
            }
        }
    }

    return(
        <div>
            { showAddComision && destinationCustomer && originCurrency && values &&
                <CurrentAccountComission       
                    form={form_commission}
                    showAddCommission
                    setShowAddComission = {setShowAddComission}
                    values={values}
                    movementsTransactions={transactionsData ? transactionsData : undefined} 
                    listComission={listComission}
                    setListCommission={setListCommission}
                    customers ={{destination: destinationCustomer, origin: originCustomer}}
                />
            }   
            <Modal 
                style={{ top: 10 }}
                title={
                    <ModalTitle
                        title={'Movimiento entre cuentas cliente'} 
                        isApproved={disabledForm.approved}
                        isDeleted={disabledForm.deleted}
                        operationNumber={disabledForm.operationNumber ? disabledForm.operationNumber : undefined}
                    />
                }
                footer={transactionsData?.approved ? null : undefined} 
                open={showForms.transferer }
                onCancel={handleCancel}  
                confirmLoading={loadingBtn}                   
                okText="Guardar"
                cancelText="Cancelar" 
                onOk={()=>form.submit()}
            >
                {!disabledForm.disable && <NewCustomer justify={"end"} positions= {'leftTop'} />}
                <Form
                    form={form}
                    id='form_deposit_extraction'
                    onFinish={handleSave}
                    layout="vertical"                    
                >   
                    <Row>
                        <Col span={14} >
                            <Form.Item
                                label='Cuenta de origen'
                                name='origin_customer'
                                rules={mandatory}
                            >   
                                <Select     
                                    disabled={disabledForm.disable}     
                                    loading={!clients }
                                    placeholder={!clients ? 'Cargando campos...' : 'Cliente'}      
                                    style={{minWidth: '200px'}} 
                                    showSearch   
                                    onChange={onChangeFirstClient}  
                                    filterOption={(input, option) =>
                                        (option?.children?.toString().toLowerCase() || '').includes(input.toLowerCase())
                                    }                                
                                >
                                    {clients && clients.map((item) => (
                                        <Option value={item.id} key={item.id} >
                                            {item.first_name + ' ' + item.last_name}
                                        </Option>
                                    ))} 
                                </Select>

                            </Form.Item>
                        </Col>
                        <Col span={10}>
                            <Form.Item
                                label='Moneda cuenta de origen'
                                name='origin_currency'                         
                                rules={mandatory}                                                   
                            >
                                <Select
                                    disabled={disabledForm.disable}    
                                    placeholder='Moneda de cuenta' 
                                    onChange={onChangeFirstCurrency}                                                                  
                                >
                                    {currency && currency.map((item) => (
                                        <Option 
                                            value={item.id} 
                                            key={item.id}
                                            sign={item.sign} 
                                        >
                                            {item.name}
                                        </Option>
                                    ))} 
                                </Select>
                            </Form.Item>
                        </Col>                                                                               
                    </Row> 
                    <Row>
                        <Col span={14}>
                            <Form.Item
                                label='Cuenta de destino'
                                name='destination_customer'
                                rules={mandatory}
                            >   
                                <Select       
                                    disabled={disabledForm.disable} 
                                    loading={!clients }
                                    placeholder={!clients ? 'Cargando campos...' : 'Cliente'}      
                                    style={{minWidth: '200px'}} 
                                    showSearch  
                                    filterOption={(input, option) =>
                                        (option?.children?.toString().toLowerCase() || '').includes(input.toLowerCase())
                                    }                                
                                >
                                    {secondSelectorList && secondSelectorList.map((item) => (
                                        <Option value={item.id} key={item.id} >
                                            {item.first_name + ' ' + item.last_name}
                                        </Option>
                                    ))} 
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={10}>
                            <Form.Item
                                label='Moneda cuenta de destino'
                                name='origin_currency'                         
                                rules={mandatory}                       
                            
                            >
                                <Select   
                                    placeholder='Moneda de cuenta'  
                                    disabled={true}                                                                                                    
                                >
                                    {secondCurrencySelectorList && secondCurrencySelectorList.map((item) => (
                                        <Option 
                                            value={item.id} 
                                            key={item.id} >
                                        {item.name}
                                        </Option>
                                    ))} 
                                </Select>
                            </Form.Item>                        
                        </Col>                                               
                    </Row>                                                       
                    <Form.Item
                        label='Monto'
                        name='amount'
                        rules={mandatory}
                    >
                        <InputNumber
                            disabled={disabledForm.disable}  
                            style={{width: '100%'}}
                            placeholder="Monto"
                            onChange={onChangeAmount}
                            addonBefore={ammmountSign}
                            formatter={value =>
                                value
                                    ? new Intl.NumberFormat('es-AR', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 20
                                    }).format(Number(value))
                                    : ''
                            }
                            onKeyDown={changePoint}
                            parser={value => value?.replace(/\./g, '').replace(',', '.') || ''}
                            stringMode 
                        />
                    </Form.Item> 
                    <Row
                        style={{marginBottom: 20}}
                    >
                        {!disabledForm.disable && 
                            <Button
                                type='primary'
                                disabled= {(destinationCustomer && originCurrency)  ? false : true }
                                onClick={addCommission}
                                style={{marginBottom: 5}}
                            >
                                Agregar comisión
                            </Button>
                        }
                        {listComission?.map((item, index)=>{
                                    let customer = clients.find?.((x)=>x.id === item.customer_id)?.first_name + ' ' + clients.find?.((x)=>x.id === item.customer_id)?.last_name
                                    let currencySelected = currency?.find?.((x)=>x.id === item?.currency_id)?.sign || ''
                                    let ammount = item?.debit
                                    let showTarget = true
                                    if(item.deleted && !item.approved_db){
                                        showTarget = false
                                    }
                                    if(showTarget){
                                        return(
                                            <Row
                                                key={index}
                                                style={{
                                                    backgroundColor: 'rgb(241, 241, 241)',
                                                    width: '100%',
                                                    borderRadius: '2px',
                                                    padding: '2px 14px',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    marginBottom: 5,
                                                    color: item.approved_db ? 'gray' : 'black',
                                                    cursor:  'pointer'
                                                }}
                                                onClick={()=>{
                                                    item.key = index
                                                    setValues(item)
                                                    setShowAddComission(true)
                                                                                                        
                                                }}                                                
                                            >
                                                <Col>{customer} </Col>   
                                                <Col>
                                                    - {currencySelected} {ammount && (ammount).toLocaleString('es-AR',{minimumFractionDigits:2, maximumFractionDigits: 2})}
                                                    {(item.approved) && <CheckOutlined style={{color:"rgb(32, 178, 170)", marginLeft: 5}}/>}
                                                    {(item.deleted) && <CloseOutlined style={{color:"red", marginLeft: 5}}/>}
                                                </Col>

                                            </Row>
                                        )
                                    }                                    
                                    })}
                    </Row>
                   
                    <Checkbox     
                        style={{marginBottom: 10}}                       
                        disabled={disabledForm.disable}  
                        checked={approved}
                        onChange={onChangeapproved}
                    >
                        Aprobado (Movimiento entre cuantas clientes)
                    </Checkbox>
                    <Form.Item
                        label='Descripción'
                        name='description'
                    >
                        <Input
                            disabled={disabledForm.disable}  
                            placeholder="Comentario"
                        />
                    </Form.Item>  
                    <span style={{color: 'orange'}}>{spanError && spanError} </span>           
                </Form>
            </Modal>
        </div>
    )
}

export default TransfersBetweenAccounts;